.bb{aspect-ratio:1/1;}